import React from "react";
import Spark from "@/components/brand/Spark";

/**
 * Editorial divider with sparks + hairline. Used between dense sections.
 */
export const Ornament = ({ tone = "dark", className = "" }) => {
  const color = tone === "dark" ? "#B58B42" : "#B58B42";
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      <span
        className="h-px"
        style={{
          width: 80,
          background:
            tone === "dark"
              ? "linear-gradient(to right, transparent, rgba(42,36,34,0.18), transparent)"
              : "linear-gradient(to right, transparent, rgba(243,239,231,0.4), transparent)",
        }}
      />
      <Spark size={12} color={color} />
      <Spark size={16} color={color} />
      <Spark size={12} color={color} />
      <span
        className="h-px"
        style={{
          width: 80,
          background:
            tone === "dark"
              ? "linear-gradient(to right, transparent, rgba(42,36,34,0.18), transparent)"
              : "linear-gradient(to right, transparent, rgba(243,239,231,0.4), transparent)",
        }}
      />
    </div>
  );
};

export default Ornament;
